/** @format */
import { MediaQuery } from '@toucan/client/global/application';

// Height of header in pixels
export const headerSizes = {
    [MediaQuery.DESKTOP]: {
        collapsed: 95,
        full: 144,
    },
    [MediaQuery.LARGE_TABLET]: 101,
    [MediaQuery.SMALL_TABLET]: 80,
};
